import React from 'react';
import ChangePassword from './ChangePassword';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.changePassword);

    //from Redux Store
    let isAuthenticated = store.getState().runtime.isStoreAuthenticated;

    if (!isAuthenticated) {
        return {
            redirect: '/store'
        }
    }

    return {
        title,
        component: <DashboardLayout><ChangePassword title={title} /></DashboardLayout>
    }
}

export default action;